import { createFileRoute } from "@tanstack/react-router";
import { UsersPage } from "@corpuscomplete/web/modules/admin/user/pages/users";

export const Route = createFileRoute("/_admin/admin/users/")({
  component: UsersPage,
});
